var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId: '20021',
      name: '动态扩展列设置明细',
      parentId: 'ID',
      parentName: '动态扩展列设置',
      parentPath: '/system/extCol',
      dataClass: 2,
      col: [],
      addParams:{
        EXT_ID:_vm.$route.query.EXT_ID
      }
    },"filterObj":{
      EXT_ID:_vm.$route.query.EXT_ID
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }